import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Clock } from "lucide-react";
import { Logo } from "@/components/common/Logo";
import { CATEGORIES, CONTACT } from "@/data/site";

const Col = ({ title, links }) => (
  <div>
    <p className="mono text-[11px] uppercase tracking-[0.2em] text-slate-400">{title}</p>
    <ul className="mt-4 space-y-2.5">
      {links.map(([to, label]) => (
        <li key={to}>
          <Link to={to} className="text-sm text-slate-300 transition-colors hover:text-white">{label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => (
  <footer className="bg-[#123634] text-slate-300" data-testid="site-footer">
    <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-5">
      <div className="lg:col-span-2">
        <Logo dark testid="footer-logo-link" />
        <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
          One-stop fire safety partner for enterprises, institutions and public spaces — supply, wall-mounting, alarm and detection wiring, and AMC under one accountable team.
        </p>
        <p className="mt-3 text-sm font-medium text-slate-200" data-testid="footer-parent-company">A part of Vingrace Solutions Private Limited</p>
        <ul className="mt-6 space-y-2 text-sm">
          <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#E0674F]" /> <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-white">{CONTACT.phone}</a></li>
          <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#E0674F]" /> <a href={`mailto:${CONTACT.email}`} className="hover:text-white">{CONTACT.email}</a></li>
          <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-[#E0674F]" /> {CONTACT.support}</li>
          <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 text-[#E0674F]" /> {CONTACT.address}</li>
        </ul>
      </div>
      <Col title="Solutions" links={CATEGORIES.slice(0, 5).map((c) => [`/solutions/${c.slug}`, c.name])} />
      <Col title="Company" links={[["/about", "About Vinsafe"], ["/projects", "Project showcase"], ["/blog", "Fire safety blog"], ["/industries", "Industries served"], ["/compliance", "Compliance"], ["/contact", "Contact"]]} />
      <Col title="Work with us" links={[["/enquiry", "Get a quote"], ["/amc", "AMC enquiry"], ["/register", "Vendor registration"], ["/login", "Vendor portal login"]]} />
    </div>
    <div className="border-t border-white/10">
      <div className="container-x flex flex-col gap-2 pb-24 pt-6 text-xs text-slate-400 sm:flex-row sm:justify-between sm:pb-6">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Vinsafe, a part of Vingrace Solutions Private Limited. All rights reserved.</p>
        <p>Consultative B2B supply · Pricing shared on enquiry</p>
      </div>
    </div>
  </footer>
);
